import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigService } from '../../../../helpers/config.service';
import { AuthAPIService } from '../../services/auth-api.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-verify-changes',
  templateUrl: './verify-changes.component.html',
  styles: ``
})
export class VerifyChangesComponent implements OnInit {

  loading: boolean = false;
  Token!: string;
  constructor(
    // public dialogRef: MatDialogRef<VerifyChangesComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: any,
    private _config: ConfigService,
    private _AuthApiService: AuthAPIService,
    private route: ActivatedRoute,
    private _router: Router) {

  }
  ngOnInit(): void {
    if (this._router.url != "/") {
      this.route.params.subscribe(params => {
        // console.log('Test ID:', params['token']);
        if (params['token']) {
          this.Token = params['token'];
          // // debugger
          this.CheckToken(this.Token);
          // this.OnConfirm()
        }
      });
    }
  }

  OnConfirm() {
    this.loading = true;
    this._AuthApiService.VerifyChanges(this.Token).subscribe({
      next: (res) => {
        this.loading = false;
        // this.dialogRef.close();
        this.OpenSuccessMessage();
        this._router.navigate(['/'])
      },
      error: (error) => {
        this.loading = false;
        this._router.navigate(['/'])
        // this.dialogRef.close();
        // Swal.fire({
        //   title: this._config._translate.instant('swalMsg.Failed'),
        //   text: error.errors[0].massage,
        //   icon: 'error',
        //   confirmButtonText: this._config._translate.instant('swalMsg.Ok'),
        // })
      },
    })
  }


  CheckToken(token: string) {
    this._AuthApiService.CheckToken(token).subscribe({
      next: (res: any) => {
        if (!res.data) {
          Swal.fire({
            title: this._config._translate.instant('swalMsg.Failed'),
            text: res.message,
            icon: 'error',
            confirmButtonText: this._config._translate.instant('swalMsg.Ok'),
          });
          this._config.goTo("/");
        }
      },
      error: (error: any) => {
        this._config.goTo("/");
      }
    })
  }


  OpenSuccessMessage() {
    // this.dialogRef.close();
    this._config.SusseccMessage(this._config._translate.instant("userProfile.Changes has been updated"))
  }


}
